import {
  List,
  Checkbox,
  Radio,
  FormControlLabel,
  Typography,
  Box,
  ListItem,
  Button,
  useMediaQuery,
  Popper,
  FormControl,
  FormGroup,
  Paper,
  Divider
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useEffect, useState, useRef, KeyboardEvent } from 'react';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import CloseIcon from '@mui/icons-material/Close';

const KnownIssuesFilterDropdown = ({
  selectedFilters,
  setSelectedFilters,
  affectedApis,
  status,
  environments,
  staticContent,
  setDropdown
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [tempFilters, setTempFilters] = useState(selectedFilters);
  const [statusMessage, setStatusMessage] = useState('');
  // const [focusedAccordion, setFocusedAccordion] = useState<string | null>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const defaultFiltersRef = useRef(selectedFilters);

  // const [detailsHidden, setDetailsHidden] = useState<Record<string, boolean>>({});



  // Add these refs for navigation
  const accordionRefs = useRef<Record<string, HTMLElement | null>>({});
  const firstOptionRefs = useRef<Record<string, HTMLInputElement | null>>({});
  const optionRefs = useRef<Record<string, (HTMLElement | null)[]>>({});


  const isMobile = useMediaQuery('(max-width: 600px)');
  const isTablet = useMediaQuery('(min-width: 601px) and (max-width: 900px)');
  const isDesktop = useMediaQuery('(min-width: 901px)');



  const actionButtonRefs = useRef<(HTMLButtonElement | null)[]>([]);


  const [open, setOpen] = useState(false);

  // Update temp filters when selectedFilters change
  useEffect(() => {
    setTempFilters(selectedFilters);
  }, [selectedFilters]);

  useEffect(() => {
    if (open) {
      const timeout = setTimeout(() => {
        actionButtonRefs.current?.[2]?.focus();
      }, 1200); // Short delay for screen reader
      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  
useEffect(() => {
  if (statusMessage) {
    const timeout = setTimeout(() => setStatusMessage(''), 1000);
    return () => clearTimeout(timeout);
  }
}, [statusMessage]);


  useEffect(() => {
    if (open) {
      const initialExpanded: Record<string, boolean> = {};
      const initialDetailsVisible: Record<string, boolean> = {};
      const initialHeaderVisible: Record<string, boolean> = {};
      Object.keys(filterOptions).forEach((category) => {
        initialExpanded[category] = true;
        initialHeaderVisible[category] = true; //Hide Headers initially
        initialDetailsVisible[category] = true; // Hide details initially
      });


    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    const initialExpanded: Record<string, boolean> = {};
    Object.keys(filterOptions).forEach((category) => {
      initialExpanded[category] = true;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (open) {
      // Store current scroll position
      const scrollY = window.scrollY;

      // Apply styles to prevent scrolling
      //document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';

      return () => {
        // Restore scroll position and remove fixed positioning
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [open]);

  const filterOptions = {
    affectedApis: Array.isArray(affectedApis)
      ? [
        ...(affectedApis[0] !== staticContent.showAll
          ? [staticContent.showAll]
          : []),
        ...affectedApis.filter((a) => a !== staticContent.showAll)
      ]
      : [staticContent.showAll],
    status: Array.isArray(status)
      ? [
        ...(status[0] !== staticContent.showAll
          ? [staticContent.showAll]
          : []),
        ...status.filter((s) => s !== staticContent.showAll)
      ]
      : [staticContent.showAll],
    environments: Array.isArray(environments)
      ? [
        ...(environments[0] !== staticContent.showAll
          ? [staticContent.showAll]
          : []),
        ...environments.filter((e) => e !== staticContent.showAll)
      ]
      : [staticContent.showAll]
  };

  // Add safety checks before modifying arrays
  if (
    filterOptions.status.length > 0 &&
    filterOptions.status[0] !== staticContent.showAll
  ) {
    filterOptions.status.unshift(staticContent.showAll);
  } else if (filterOptions.status.length === 0) {
    filterOptions.status = [staticContent.showAll];
  }

  if (
    filterOptions.environments.length > 0 &&
    filterOptions.environments[0] !== staticContent.showAll
  ) {
    filterOptions.environments.unshift(staticContent.showAll);
  } else if (filterOptions.environments.length === 0) {
    filterOptions.environments = [staticContent.showAll];
  }

 


  const handleResetFilters = () => {
    setTempFilters(defaultFiltersRef.current);
    setStatusMessage(staticContent.statusMessage);
  };


  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setTempFilters(selectedFilters);
    setOpen(!open)

    // Set focus to first accordion after opening
    // setTimeout(() => {
    //   const firstCategory = Object.keys(filterOptions)[0];
    //   // setFocusedAccordion(firstCategory);
    //   accordionRefs.current[firstCategory]?.focus();
    // }, 100);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (!open) {
        setAnchorEl(event.currentTarget);
        setTempFilters(selectedFilters);
        setOpen(!open)

        // Set focus to first accordion after opening
        // setTimeout(() => {
        //   const firstCategory = Object.keys(filterOptions)[0];
        //   // setFocusedAccordion(firstCategory);
        //   accordionRefs.current[firstCategory]?.focus();
        // }, 100);
      } else {
        handleClose();
      }
    } else if (event.key === 'Escape' && open) {
      event.preventDefault();
      setTempFilters(selectedFilters);
      handleClose();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false)

    // setFocusedAccordion(null);
    setTempFilters(selectedFilters);

    triggerRef.current?.focus();
  };

  const handleSelect = (category, option) => {
    if (option === staticContent.showAll) {
      setTempFilters((prev) => ({
        ...prev,
        [category]: [staticContent.showAll]
      }));
    } else {
      setTempFilters((prev) => {
        const current = prev[category] || [];
        let updated;
        if (current.includes(option)) {
          updated = current.filter(
            (item) => item !== option && item !== staticContent.showAll
          );
          if (updated.length === 0) {
            updated = [staticContent.showAll];
          }
        } else {
          updated = [
            ...current.filter((item) => item !== staticContent.showAll),
            option
          ];
        }
        return { ...prev, [category]: updated };
      });
    }
  };

  const getAppliedFilters = () => {
    const applied: { category: string; value: string }[] = [];

    Object.keys(tempFilters).forEach((category) => {
      const current = tempFilters[category] || [];
      const defaults = defaultFiltersRef.current[category] || [];

      current.forEach((value) => {
        if (
          value !== staticContent.showAll &&
          !defaults.includes(value)
        ) {
          applied.push({ category, value });
        }
      });
    });

    return applied;
  };

  const appliedFilters = getAppliedFilters();

  const appliedFiltersCount = appliedFilters.length;

  const singleFilterLabel = appliedFiltersCount === 1 ? appliedFilters[0].value : null;


  const handleApplyFilters = () => {
    // Only apply on mobile

    setSelectedFilters(tempFilters);


    setStatusMessage(
     'Applied Selected Filters'
    );


    handleClose();

  };

  const handleActionButtonKeyDown = (
    event: KeyboardEvent,
    index: number
  ) => {

   
    const categories = Object.keys(filterOptions);


    if (event.key === 'Tab') {
      event.preventDefault();

      if (event.shiftKey) {
        // ← Shift + Tab
        if (index === 2) {
          actionButtonRefs.current[0]?.focus();
        }
        else {

          if (index === 0) {
            actionButtonRefs.current[1]?.focus();
          } else {
            // Go back to last option of last category
            const lastCategory = categories[categories.length - 1];
            const opts = optionRefs.current[lastCategory] || [];
            const lastOpt = opts[opts.length - 1];
            const el = lastOpt?.querySelector?.('input') || lastOpt;
            el?.focus();
          }
        }
      }
      else {
        // → Tab
        if (index === 2) {
          const firstCategory = categories[0];
          const opts = optionRefs.current[firstCategory] || [];
          const firstOpt = opts[0];
          const el = firstOpt?.querySelector?.('input') || firstOpt;
          el?.focus();
          console.log(el)
        } else {
          if (index === 1) {
            actionButtonRefs.current[index-1]?.focus();
          } else {
            // Wrap to first accordion header
            actionButtonRefs.current[2]?.focus();
          }
        }
      }
    }
  }


  const handleOptionKeyDown = (
    event: KeyboardEvent,
    category: string,
    option: string,
    optionIndex: number
  ) => {
    const categories = Object.keys(filterOptions);
    const currentCategoryIndex = categories.indexOf(category);
    const categoryOptions = filterOptions[category];
    const currentOptionIndex = optionIndex;
    if (event.key === ' ') {
      event.preventDefault();
      handleSelect(category, option);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      handleSelect(category, option);
    } else if (event.key === 'Tab') {
      event.preventDefault();
      event.stopPropagation();

      if (event.shiftKey) {
        // Shift+Tab - go backwards
        if (currentOptionIndex > 0) {
          const prevOptionIndex = currentOptionIndex - 1;
          const prevOptionRef = optionRefs.current[category]?.[prevOptionIndex];

          if (prevOptionRef) {
            const inputElement = prevOptionRef.querySelector('input') || prevOptionRef;
            setTimeout(() => inputElement.focus(), 0);

          }
        } else {
          // Go to accordion header

          if (category === 'affectedApis' && currentOptionIndex === 0) {

            actionButtonRefs.current[2]?.focus()
          }
          else {

            const prevCategoryIndex = currentCategoryIndex - 1;
            const prevCategory = categories[prevCategoryIndex];

            const prevCategoryOptions =
              optionRefs.current[prevCategory];

            if (prevCategoryOptions?.length) {
              const lastOptionIndex =
                prevCategoryOptions.length - 1;

              const lastOptionRef =
                prevCategoryOptions[lastOptionIndex];

              if (lastOptionRef) {
                const inputElement =
                  lastOptionRef.querySelector('input') || lastOptionRef;

                setTimeout(() => inputElement.focus(), 0);
              }
            }
          }

        }
      } else {
        // Normal Tab - go forward

        if (currentOptionIndex < categoryOptions.length - 1) {
          const nextOptionIndex = currentOptionIndex + 1;
          const nextOptionRef = optionRefs.current[category]?.[nextOptionIndex];
          if (nextOptionRef) {
            const inputElement = nextOptionRef.querySelector('input') || nextOptionRef;
            setTimeout(() => inputElement.focus(), 0);
          }
        } else {
          // We're at the last option of this category
          // Move focus to the next accordion header (not details)

          // Last option of LAST category → go to Apply button
          if (
            currentCategoryIndex === categories.length - 1 &&
            currentOptionIndex === categoryOptions.length - 1
          ) {
            setTimeout(() => {
              actionButtonRefs.current[1]?.focus();
            }, 0);
            return;
          }
          const nextCategoryIndex =
            currentCategoryIndex < categories.length - 1
              ? currentCategoryIndex + 1
              : 0;
          const nextCategory = categories[nextCategoryIndex];
          
          
          const firstOptionRef = optionRefs.current[nextCategory]?.[0];

          if (firstOptionRef) {
            const inputElement = firstOptionRef.querySelector('input') || firstOptionRef;
            setTimeout(() => inputElement.focus(), 0);

          }
        }
      }
      return;
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation();

      // Move to next option in the same category
      if (currentOptionIndex < categoryOptions.length - 1) {
        const nextOptionIndex = currentOptionIndex + 1;
        const nextOptionRef = optionRefs.current[category]?.[nextOptionIndex];
        if (nextOptionRef) {
          // Find the actual input element within the MUI component
          const inputElement =
            nextOptionRef.querySelector('input') || nextOptionRef;
          setTimeout(() => {
            inputElement.focus();
          }, 0);
        }
      } else {
        // If at last option, move to next accordion
        const nextCategoryIndex =
          currentCategoryIndex < categories.length - 1
            ? currentCategoryIndex + 1
            : 0;
        const nextCategory = categories[nextCategoryIndex];
        // setFocusedAccordion(nextCategory);
        const nextAccordionRef = accordionRefs.current[nextCategory];
        if (nextAccordionRef) {
          setTimeout(() => {
            nextAccordionRef.focus();
          }, 0);
        }
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      event.stopPropagation();

      // Move to previous option in the same category
      if (currentOptionIndex > 0) {
        const prevOptionIndex = currentOptionIndex - 1;
        const prevOptionRef = optionRefs.current[category]?.[prevOptionIndex];
        if (prevOptionRef) {
          // Find the actual input element within the MUI component
          const inputElement =
            prevOptionRef.querySelector('input') || prevOptionRef;
          setTimeout(() => {
            inputElement.focus();
          }, 0);
        }
      } else {
        // If at first option, go back to accordion header
        const accordionRef = accordionRefs.current[category];
        if (accordionRef) {
          setTimeout(() => {
            accordionRef.focus();
          }, 0);
        }
      }
    } else if (event.key === 'Escape') {
      event.preventDefault();
      setTempFilters(selectedFilters);
      handleClose();
      triggerRef.current?.focus();
    }
  };

  const label = staticContent.applyAriaLabel.split("")
  label.splice(20,0,`${appliedFiltersCount?`(${appliedFiltersCount}) `:""}`)
  const applyLabel= label.join("")


  return (
    <>

      <Box
        aria-live="polite"
        aria-atomic="true"
        sx={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden'
        }}
      >
        {statusMessage}
      </Box>

      <Button
        variant='secondary'
        size='xl'
        ref={triggerRef}
        aria-live="off"
        sx={{
          width:'auto !important',
          minWidth: `${isDesktop ? '141px' : isTablet ? '141px' : '164px'}`,
          
          maxWidth: '312px',
          padding: '4px 12px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          border: '1px solid',
          color: `${open?'#002345':'#1460AA'}`,

          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          },
          '&:focus': {
            outline: '2px solid #1460AA',
            outlineOffset: '2px',
            backgroundColor: 'rgba(20, 96, 170, 0.04)'
          }
        }}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        aria-label={staticContent.filterAriaLabel}
        aria-expanded={open}
        aria-haspopup="dialog"
        startIcon={<FilterListIcon sx={{ color: `${open?'#002345':'#1460AA'}`, width: '20px', height: '20px', }} />}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>

          <Typography
          //aria-live="polite"
            sx={{
              fontSize: '14px',
              lineHeight: '20px',
              fontWeight: 700,
              color: `${open?'#002345':'#1460AA'}`,
              
            }}
          >
            {appliedFiltersCount === 0 ? staticContent.filterLabel
              : singleFilterLabel
                ? `${staticContent.filterLabel}: ${singleFilterLabel}`
                : `${staticContent.filterLabel} (${appliedFiltersCount})`}
          </Typography>
        </Box>
        {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon  sx={{color:`${open?'#002345':'#1460AA'}`}}/>}
      </Button>

      <Popper
       role='dialog'
       aria-modal='true'
        open={open}
        anchorEl={anchorEl}
        ref={(el) => {
          if (el && open) {
            setDropdown(el.offsetHeight - 90 ); // 15 = margin-top
          }else{
            setDropdown(0)
          }
        }}
        // anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        // transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        //disableScrollLock={true}
        disablePortal={false}
        //  disableRestoreFocus={true}
        // transitionDuration={0}
      >
        <TrapFocus open={open}>
          <>
            {/* Hidden title for dialog announcement */}
           
            {(
              // Desktop/tablet view (existing)
              <Paper
                sx={{
                  minWidth: { xs: '345px', sm: '288px' },
                  maxWidth: { xs: '345px', sm: '288px' },
                  backgroundColor: '#ffff',
                  boxShadow: '0px 0px 15px rgba(0,0,0,0.15)',
                  padding: '16px',
                  borderRadius: '16px',
                  mt: '15px'
                }}
              >
                {Object.entries(filterOptions).map(([category, options], index) => {

                  return (
                    <>
                      <Box sx={{ minWidth: `${isMobile ? '330px' : '275px'}`, display: 'flex', mb: '16px', justifyContent: 'space-between', alignItems: 'center' }}>

                        <Typography
                          component="h3"
                          variant="h6"
                          id={`heading-${index}`}
                          sx={{ fontWeight: 700 }}
                          aria-label={`${staticContent.filterDropLabel[index]}`}
                        >
                          {staticContent.filterDrop[index]}
                        </Typography>
                        <div
                          ref={(el) => (accordionRefs.current[category] = el)}
                          tabIndex={-1}
                          aria-hidden="true"
                        />

                        {category === 'affectedApis' && index=== 0?
                          <Button aria-label={`${staticContent.closeLabel}`} variant='text' size='md' ref={el => { actionButtonRefs.current[2] = el }} onClick={handleClose} onKeyDown={e => handleActionButtonKeyDown(e, 2)} sx={{ fontSize: '32px', '&.Mui-focusVisible': { outline: '2px solid black', outlineOffset: '2px' } }} ><CloseIcon aria-hidden='true'></CloseIcon></Button> : null}
                      </Box>
                      <FormControl component='fieldset'>
                        <legend
                        aria-labelledby={`heading-${index}`}
                          style={{
                            position: 'absolute',
                            left: '-10000px',
                            top: 'auto',
                            width: '1px',
                            height: '1px',
                            overflow: 'hidden'
                          }}
                        >{staticContent.filterDropLabel[index]}
                        </legend>
                        <FormGroup   aria-labelledby={`heading-${index}`}>

                          <List disablePadding
                            sx={{ display: 'flex', flexDirection: 'column', gap: '0px' }}
                          
                          >
                            {Array.isArray(options) &&
                              options.map((option, idx) => {
                                const isSelected = (
                                  tempFilters[category] || []
                                ).includes(option);
                                return (
                                  <ListItem
                                    key={option}
                                    disableGutters
                                    disablePadding
                                    sx={{
                                      display: 'flex',
                                      '&:focus-within': {
                                        backgroundColor: 'rgba(20, 96, 170, 0.04)',

                                      }
                                    }}
                                  >
                                    {idx === 0 ? (
                                      <FormControlLabel
                                        control={
                                          <Radio
                                            aria-label='All'
                                            ref={(el) => {
                                              if (idx === 0)
                                                firstOptionRefs.current[category] =
                                                  el as HTMLInputElement | null;
                                              if (!optionRefs.current[category]) {
                                                optionRefs.current[category] = [];
                                              }
                                              if (el)
                                                optionRefs.current[category][idx] =
                                                  el;
                                            }}
                                            checked={(
                                              tempFilters[category] || []
                                            ).includes(staticContent.showAll)}
                                            onChange={() =>
                                              handleSelect(
                                                category,
                                                staticContent.showAll
                                              )
                                            }
                                            onKeyDown={(event) =>
                                              handleOptionKeyDown(
                                                event,
                                                category,
                                                staticContent.showAll,
                                                idx
                                              )
                                            }
                                            sx={{
                                              fontWeight: 500,
                                              '&.Mui-focusVisible': {
                                                outline: '2px solid #1460AA',
                                                outlineOffset: '2px'
                                              }, '&.Mui-checked': {
                                                color: '#002345',
                                              }
                                            }}
                                            // role="option"
                                            // aria-selected={(
                                            //   tempFilters[category] || []
                                            // ).includes(staticContent.showAll)}
                                            inputProps={{
                                              role: 'checkbox',
                                              'aria-label': option
                                            }}
                                          />
                                        }
                                        label={
                                          <span style={{ fontWeight: 500 }} aria-hidden="true">{option}</span>
                                        }
                                        sx={{
                                          '& .MuiFormControlLabel-label': {
                                            fontSize: '14px'
                                          }
                                        }}
                                      />
                                    ) : (
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            ref={(el) => {
                                              if (!optionRefs.current[category]) {
                                                optionRefs.current[category] = [];
                                              }
                                              if (el)
                                                optionRefs.current[category][idx] =
                                                  el;
                                            }}
                                            checked={isSelected}
                                            onChange={() => {
                                              handleSelect(category, option);
                                            }}
                                            onKeyDown={(event) =>
                                              handleOptionKeyDown(
                                                event,
                                                category,
                                                option,
                                                idx
                                              )
                                            }
                                            sx={{
                                              fontWeight: 500,
                                              color: '#1460AA',
                                              '&.Mui-focusVisible': {
                                                outline: '2px solid #1460AA',
                                                outlineOffset: '2px'
                                              },
                                              '&.Mui-checked': {
                                                color: '#002345',
                                              },
                                            }}
                                            // role="option"
                                            // aria-selected={isSelected}
                                            inputProps={{
                                              'aria-label': option
                                            }}
                                          />
                                        }
                                        label={
                                          <span style={{ fontWeight: 500 }} aria-hidden="true">{option}</span>
                                        }
                                        sx={{
                                          '& .MuiFormControlLabel-label': {
                                            fontSize: '14px'
                                          }
                                        }}
                                      />
                                    )}

                                  </ListItem>
                                );
                              })}
                          </List>

                        </FormGroup>
                      </FormControl>

                      {index < 2 ? <Divider sx={{ mb: '16px', mt: '16px' }}></Divider> : null}
                    </>


                  );
                })}
                <Box sx={{ mt: '16px', display: 'flex', gap: '16px', flexDirection:`${isMobile?'column':'row'}`, width:`${isMobile?'100%':'auto'}`}}>
                  <Button sx={{width:`${isMobile?'100%':'auto'}`, maxWidth:`${isMobile?'100% !important':'auto'}`}} ref={el => { actionButtonRefs.current[1] = el }} onClick={handleResetFilters} onKeyDown={e => handleActionButtonKeyDown(e, 1)} variant='secondary' size='xs'>{staticContent.resetLabel}</Button>
                  <Button aria-label={`${applyLabel}`} sx={{width:`${isMobile?'100%':'auto'}`, maxWidth:`${isMobile?'100% !important':'auto'}`}} ref={el => { actionButtonRefs.current[0] = el }} onClick={handleApplyFilters} onKeyDown={e => handleActionButtonKeyDown(e, 0)} variant='primary' size='sm'>{staticContent.applyLabel}</Button>
                </Box>
              </Paper>
            )}
          </>
        </TrapFocus>
      </Popper>
    </>
  );
};

export default KnownIssuesFilterDropdown;